import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
	ObjectType,
	PopularityRankTypes,
	StreamingChartObjectType,
	StreamingChartsTitlesEdge,
} from '@/@types/graphql-types';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import TitleDetailStreamingChartList from '@/components/details/streaming-chart/TitleDetailStreamingChartList.vue';
import { sliceTitles, provideStreamingChartSpinningText } from '@/helpers/streaming-chart-helper';
import { useQuery } from '@/helpers/composables/useApollo';
import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';

import {
	GetStreamingChartInfoDocument,
	GetStreamingChartInfoQuery,
	GetStreamingChartInfoQueryVariables,
} from '@/components/graphql/queries/GetStreamingChartInfo.query';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailStreamingChart',
  props: {
    titleId: null,
    titleName: null,
    titleObjectType: null,
    lastUpdated: { default: '' },
    isSidebar: { type: Boolean, default: false },
    range: { default: 4 }
  },
  setup(__props: any) {

const props = __props as { titleId: string, titleName: string, titleObjectType: ObjectType, lastUpdated: string | number | Date, isSidebar: boolean, range: number };



const { country, language } = useLanguageStore();

const filter = {
	jwEntityID: props.titleId,
	category: PopularityRankTypes.DailyPopularitySameContentType,
	previousTitles: props.range * 2 + 1,
	nextTitles: props.range * 2 + 1,
	objectType: props.titleObjectType as unknown as StreamingChartObjectType,
};

const queryVariables = computed<GetStreamingChartInfoQueryVariables>(() => {
	return {
		language: language.value,
		country: country.value,
		withOffers: false,
		filter,
		first: (props.range * 2 + 1) * 2 + 1,
		after: '',
		countryStreamingCharts: country.value,
	};
});

const { result, onError } = useQuery<GetStreamingChartInfoQuery, GetStreamingChartInfoQueryVariables>(
	GetStreamingChartInfoDocument,
	queryVariables,
	{ errorPolicy: 'all' }
);

onError(error => {
	captureMessageForSentry(
		'[GraphQL Get Streaming Chart Data]:',
		{ error, where: 'Component: TitleDetailStreamingChart' },
		'error'
	);
});

const streamingChartData = computed(() => result.value?.streamingCharts);

const streamingChartTitles = computed(() =>
	sliceTitles(props.titleId, streamingChartData.value?.edges ?? [], props.range)
);

const streamingChartLastUpdated = computed(() => {
	const title =
		streamingChartData?.value?.edges?.find(title => title?.node?.id === props.titleId) ||
		({} as StreamingChartsTitlesEdge);
	return title?.streamingChartInfo?.updatedAt;
});

const renderChart = computed(() => streamingChartTitles.value?.length > 0);

const titleDetailTitle = computed(() => streamingChartTitles.value?.find(title => title.node.id === props.titleId));

const titleNodes = computed(() => {
	return streamingChartTitles.value;
});

function trackClick(event: { index: number; title: StreamingChartsTitlesEdge }) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'title_clicked',
		label: `${props.titleId}, ${event.title.node.id}`,
		property: 'streaming_chart',
		value: event.index,
	});
}

return { __sfc: true,props, country, language, filter, queryVariables, result, onError, streamingChartData, streamingChartTitles, streamingChartLastUpdated, renderChart, titleDetailTitle, titleNodes, trackClick, TitleDetailStreamingChartList, provideStreamingChartSpinningText, faInfoCircle }
}

})